<template>
  <v-container fluid class="admin-page">
    <v-row class="align-center" justify="space-around">
      <v-col cols="6">
        <h2>Affiliates</h2>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col cols="8">
            <v-text-field
              v-model="searchAffiliate"
              label="Search Affiliate Name"
              append-icon="mdi-magnify"
              solo
              clearable
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <router-link to="/dashboard/add/affiliate">
              <v-btn
                class="text--futura text--white text-capitalize"
                dark
                block
              >
                Add Affiliate
              </v-btn>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col cols="12">
        <Alert />
        <div class="elevation-1 white">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Full Name</th>
                  <th class="text-left">Affiliate Code</th>
                  <th class="text-left">Contact Number</th>
                  <th class="text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="tableLoading">
                  <td colspan="4" class="affiliate-cell text-center py-6">
                    Loading...
                  </td>
                </tr>
                <tr v-else-if="filteredAffiliates.length === 0">
                  <td colspan="4" class="affiliate-cell text-center py-6">
                    No affiliate data
                  </td>
                </tr>
                <tr v-for="item in paginatedAffiliates" :key="item.id">
                  <td>
                    <span class="affiliate-cell">{{ item.fullName }}</span>
                  </td>
                  <td>
                    <span class="affiliate-cell">{{ item.affiliateCode }}</span>
                  </td>
                  <td>
                    <span class="affiliate-cell">{{ item.contactNumber }}</span>
                  </td>
                  <td>
                    <v-icon small class="mr-2" @click="showItem(item)">mdi-eye</v-icon>
                    <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <v-row class="mt-4 align-center" justify="space-between">
          <v-col cols="3">
            <v-select
              v-model="itemsPerPage"
              :items="[10, 25, 50, 100]"
              label="Rows per page"
              dense
              solo
            ></v-select>
          </v-col>
          <v-col cols="4" class="text-right affiliate-cell">
            {{ pageStart }}-{{ pageEnd }} of {{ filteredAffiliates.length }}
          </v-col>
          <v-col cols="5" class="d-flex justify-end">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Alert from "@/components/Alert.vue";

export default {
  name: "Affiliate",
  components: {
    Alert,
  },
  data() {
    return {
      searchAffiliate: "",
      page: 1,
      itemsPerPage: 25,
    };
  },
  computed: {
    affiliates() {
      return this.$store.state.affiliates;
    },
    tableAffiliates() {
      return (this.affiliates || []).map((affiliate) => ({
        id: affiliate.id,
        fullName: this.cleanValue(affiliate.fullName || affiliate.full_name),
        affiliateCode: this.cleanValue(
          affiliate.affiliateCode || affiliate.affiliate_code
        ),
        contactNumber: this.cleanValue(
          affiliate.contactNumber || affiliate.contact_number
        ),
      }));
    },
    filteredAffiliates() {
      const keyword = this.searchAffiliate.trim().toLowerCase();

      if (!keyword) return this.tableAffiliates;

      return this.tableAffiliates.filter((affiliate) =>
        affiliate.fullName.toLowerCase().includes(keyword)
      );
    },
    paginatedAffiliates() {
      const start = (this.page - 1) * this.itemsPerPage;
      return this.filteredAffiliates.slice(start, start + this.itemsPerPage);
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.filteredAffiliates.length / this.itemsPerPage));
    },
    pageStart() {
      if (this.filteredAffiliates.length === 0) return 0;
      return (this.page - 1) * this.itemsPerPage + 1;
    },
    pageEnd() {
      return Math.min(this.page * this.itemsPerPage, this.filteredAffiliates.length);
    },
    tableLoading() {
      return this.$store.state.tableLoading;
    },
  },
  watch: {
    searchAffiliate() {
      this.page = 1;
    },
    itemsPerPage() {
      this.page = 1;
    },
    page(value) {
      if (value > this.pageCount) {
        this.page = this.pageCount;
      }
    },
  },
  methods: {
    cleanValue(value) {
      if (value === null || value === undefined) return "-";
      const normalized = String(value).trim();
      return normalized || "-";
    },
    editItem(item) {
      this.$router.push({
        path: `/dashboard/edit/affiliate/${item.id}`,
      });
    },
    showItem(item) {
      this.$router.push({
        path: `/dashboard/affiliate/${item.id}`,
      });
    },
  },
  created() {
    this.$store.dispatch("getAffiliates");
  },
};
</script>

<style scoped>
.affiliate-cell {
  color: #000000;
}
</style>
